module.exports = __webpack_public_path__ + "img/ScanQRCN.c3d408e5.png";